import { defineAction } from '~/prix'
import { z } from 'zod'
import creditRequestDeleteAction from './creditRequestDelete.action.json' with { type: 'json' }
import { creditRequestObject } from '../creditRequestObject'

const creditRequestDeleteDefinition = defineAction({
  ...creditRequestDeleteAction,

  input: z.object({ id: creditRequestObject.shape.id }),
  output: z.object({}),
})

export default creditRequestDeleteDefinition

